import HasID from "./HasID";

export interface Shipment extends HasID {
    shipmentType: string,
    verified: Date,
    verifiedBy: string,
    shipped: Date,
    shippedBy: string,
    voided: boolean,
    avalaraDocumentId: string,
    trackingNumber: string,
    shippingStation: string,
    shippingCost: number,
    serviceType: string,
    trackingUrl: string,
    shipEngineShipmentId: string,
    delivered: boolean,
    anticipatedDeliveryDate: Date,
    actualDeliveryDate: Date,
    deliveryConfirmationDate: Date,
    deliveryConfirmationIP: string,
    deliveryConfirmationSignature: string
}

export class Shipment {

}
